// extracted by mini-css-extract-plugin
export default {"addFeed":"styles_addFeed__gS7KL"};